/* ECOREINA — Pack multi-SKU v5
 * 1) Product page: add multi-line items, open cart drawer (no reload)
 * 2) Size guide modal: clone theme's .sc-nuevo behaviour per component
 * 3) Cart drawer: reorder pack-master layout (title → components → qty → AHORRA EN PACKS),
 *    intercept -/+ and Eliminar to act at pack level (remove ALL items in pack),
 *    recalculate cart count to show pack count instead of raw line count.
 */
(function () {
  'use strict';

  // ─── Money helpers (EUR "€88,71" style, comma decimal) ───
  function _parseMoney(str) {
    if (!str) return 0;
    var s = String(str).replace(/[^\d.,]/g, '');
    if (!s) return 0;
    var lastDot = s.lastIndexOf('.'), lastComma = s.lastIndexOf(',');
    if (lastDot > -1 && lastComma > -1) {
      if (lastComma > lastDot) { s = s.replace(/\./g, '').replace(',', '.'); }
      else { s = s.replace(/,/g, ''); }
    } else if (lastComma > -1) {
      s = s.replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }
  function _fmtMoney(n) {
    return '€' + n.toFixed(2).replace('.', ',');
  }

  // ─── 1) Product page: add-to-cart ─────────────────────────────────
  function initPackPage() {
    var wrap = document.querySelector('.pack-multi-wrap');
    if (!wrap) return;

    var btn = wrap.querySelector('.pack-multi-cta');
    var err = wrap.querySelector('.pack-multi-error');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      err.classList.remove('is-visible');

      var rows = wrap.querySelectorAll('.pack-multi-row');
      var items = [];
      var packId = wrap.dataset.packId || 'pack';
      var packLabel = wrap.dataset.packLabel || 'Pack';
      var packImageUrl = wrap.dataset.packImageUrl || '';
      var packIndex = 0;

      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var sel = row.querySelector('.pack-multi-row__select');
        var componentTitle = row.dataset.componentTitle || '';
        var qty = parseInt(row.dataset.qty || '1', 10);

        if (!sel || !sel.value) {
          err.textContent = 'Por favor selecciona la talla de "' + componentTitle + '".';
          err.classList.add('is-visible');
          return;
        }
        var opt = sel.options[sel.selectedIndex];
        if (opt && opt.disabled) {
          err.textContent = 'La talla seleccionada para "' + componentTitle + '" no está disponible.';
          err.classList.add('is-visible');
          return;
        }
        var sizeChoice = opt ? opt.textContent : '';

        for (var k = 0; k < qty; k++) {
          items.push({
            id: parseInt(sel.value, 10),
            quantity: 1,
            properties: {
              _pack_id: packId,
              _pack_label: packLabel,
              _pack_image_url: packImageUrl,
              _pack_index: String(packIndex),
              _pack_master: packIndex === 0 ? '1' : '0',
              _pack_component_title: componentTitle,
              _pack_component_size: sizeChoice
            }
          });
          packIndex++;
        }
      }

      btn.disabled = true;
      btn.textContent = 'Añadiendo...';

      var resetBtn = function () {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText || 'AÑADIR PACK AL CARRITO';
      };
      var safetyTimer = setTimeout(function () {
        resetBtn();
        err.textContent = 'La operación tardó demasiado. Refresca la página e inténtalo de nuevo.';
        err.classList.add('is-visible');
      }, 20000);

      // Ask Shopify to return updated cart-drawer + page-header HTML in the response.
      // This is the SAME approach the theme's own add-to-cart uses (main.js line 2731).
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,page-header',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw j; });
          return r.json();
        })
        .then(function (data) {
          // Update cart drawer using the theme's OFFICIAL method (proper CartDrawer/CartForm integration)
          try {
            var drawer = document.querySelector('cart-drawer');
            if (drawer && data.sections && data.sections['cart-drawer']
                && typeof drawer.updateFromCartChange === 'function') {
              drawer.updateFromCartChange(data.sections['cart-drawer']);
            }
          } catch (e) { console.error('[pack] drawer update error:', e); }

          // Update page-header (cart count bubble) — no dedicated theme method for this
          try {
            if (data.sections && data.sections['page-header']) {
              var header = document.querySelector('page-header');
              if (header) {
                var parser = new DOMParser();
                var hDoc = parser.parseFromString(data.sections['page-header'], 'text/html');
                var newHeader = hDoc.querySelector('page-header');
                if (newHeader) header.innerHTML = newHeader.innerHTML;
              }
            }
          } catch (e) { console.error('[pack] header update error:', e); }

          // Notify header + other listeners
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));

          // Decorate pack items (group into single visual item)
          // Wait a tick so refreshFromHtml finishes updating DOM
          setTimeout(function () {
            try { decoratePackInCart(document); } catch (e) { console.error('[pack] decorate error:', e); }
          }, 100);

          // Open drawer using theme's official method
          try {
            var drawerEl = document.querySelector('.js-cart-drawer');
            if (drawerEl && typeof drawerEl.open === 'function') {
              drawerEl.open();
            } else {
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
            }
          } catch (e) { console.error('[pack] drawer open error:', e); }
        })
        .catch(function (err2) {
          console.error('[pack] add-to-cart error:', err2);
          var msg = (err2 && (err2.description || err2.message)) || 'No se pudo añadir el pack al carrito.';
          err.textContent = msg;
          err.classList.add('is-visible');
        })
        .finally(function () {
          clearTimeout(safetyTimer);
          resetBtn();
        });
    });
  }

  // ─── Helper: refresh cart-drawer + page-header sections, then decorate ───
  function refreshAndOpenDrawer() {
    return fetch('/?sections=cart-drawer,page-header', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections['cart-drawer']) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = newDoc.querySelector('cart-drawer');
            if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          }
        }
        if (sections && sections['page-header']) {
          var header = document.querySelector('page-header');
          if (header) {
            var parser2 = new DOMParser();
            var hDoc = parser2.parseFromString(sections['page-header'], 'text/html');
            var newHeader = hDoc.querySelector('page-header');
            if (newHeader) header.innerHTML = newHeader.innerHTML;
          }
        }
        decoratePackInCart(document);

        var drawerEl = document.querySelector('.js-cart-drawer');
        if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
        else document.dispatchEvent(new CustomEvent('theme:open-cart-drawer', { bubbles: true }));
      });
  }

  function refreshDrawerSilently() {
    return fetch('/?sections=cart-drawer,page-header', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections && sections['cart-drawer']) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newDrawer = newDoc.querySelector('cart-drawer');
            if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
          }
        }
        if (sections && sections['page-header']) {
          var header = document.querySelector('page-header');
          if (header) {
            var parser2 = new DOMParser();
            var hDoc = parser2.parseFromString(sections['page-header'], 'text/html');
            var newHeader = hDoc.querySelector('page-header');
            if (newHeader) header.innerHTML = newHeader.innerHTML;
          }
        }
        decoratePackInCart(document);
      });
  }

  // ─── 2) Size guide modal ──────────────────────────────────────────
  function initSizeGuideModals() {
    var modals = document.querySelectorAll('.pack-sc-modal');
    if (!modals.length) return;

    modals.forEach(function (modal) {
      var sc = modal.querySelector('.sc-nuevo');
      if (!sc) return;
      var idx = sc.dataset.packScIndex;
      var rawEl = document.getElementById('sc-raw-pack-' + idx);
      var tablaWrap = sc.querySelector('.sc-tabla-wrap');
      var medidasWrap = sc.querySelector('.sc-medidas-wrap');
      if (!rawEl || !tablaWrap || !medidasWrap) return;
      if (sc.dataset.scInitialized === '1') return;
      sc.dataset.scInitialized = '1';

      var raw = rawEl.cloneNode(true);
      raw.removeAttribute('id');
      raw.style.display = '';
      raw.setAttribute('aria-hidden', 'false');
      var tables = raw.querySelectorAll('table');
      tables.forEach(function (t) { tablaWrap.appendChild(t.cloneNode(true)); t.remove(); });
      while (raw.firstChild) medidasWrap.appendChild(raw.firstChild);

      var tabs = sc.querySelectorAll('.sc-tab');
      var panels = sc.querySelectorAll('.sc-panel');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var which = tab.dataset.scTab;
          tabs.forEach(function (t) {
            var active = t === tab;
            t.classList.toggle('sc-tab--active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('sc-panel--active', p.dataset.scPanel === which);
          });
        });
      });

      var lunaBtn = sc.querySelector('[data-pack-luna-trigger]');
      if (lunaBtn) {
        lunaBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var closeBtn = modal.querySelector('.js-close-modal');
          if (closeBtn) closeBtn.click();
          setTimeout(function () {
            var bubble = document.getElementById('luna-bubble');
            if (bubble) bubble.click();
          }, 250);
        });
      }
    });
  }

  // ─── 3) Cart drawer / cart page: pack item layout + remove logic ───
  function getLineItemKey(el) {
    // Multiple fallbacks for line-item key
    if (el.dataset.lineKey) return el.dataset.lineKey;
    if (el.dataset.key) return el.dataset.key;
    var qtyInput = el.querySelector('.cart-item__quantity-input, [name="updates[]"]');
    if (qtyInput && qtyInput.dataset.key) return qtyInput.dataset.key;
    var removeLink = el.querySelector('.cart-item__remove');
    if (removeLink && removeLink.href) {
      var m = removeLink.href.match(/[?&]id=([^&]+)/);
      if (m) return decodeURIComponent(m[1]);
    }
    return null;
  }

  // Observer + re-entry guard state
  var _drawerObserver = null;
  var _isDecorating = false;

  function decoratePackInCart(scope) {
    // Re-entry guard: prevent recursion from observer catching our own mutations
    if (_isDecorating) return;
    _isDecorating = true;

    // Disconnect observer while we mutate so we don't cascade
    if (_drawerObserver) { try { _drawerObserver.disconnect(); } catch (e) {} }

    try {
      _doDecoratePackInCart(scope || document);
    } catch (e) {
      console.error('[pack] decorate error:', e);
    }

    // Re-attach observer AFTER mutations settle (next tick + a safety margin)
    setTimeout(function () {
      try {
        var drawer = document.querySelector('cart-drawer, .cart-drawer, .cart-item-list__body');
        if (drawer && _drawerObserver) {
          _drawerObserver.observe(drawer, { childList: true, subtree: true });
        }
      } catch (e) {}
      _isDecorating = false;
    }, 150);
  }

  function _doDecoratePackInCart(scope) {
    // Only consider items that have NOT been processed yet (avoids re-doing work)
    var allItems = scope.querySelectorAll('.cart-item[data-pack-id]');
    if (!allItems.length) {
      recalcCartCount();
      return;
    }

    var groups = {};
    allItems.forEach(function (el) {
      var pid = el.getAttribute('data-pack-id');
      if (!pid) return;
      if (!groups[pid]) groups[pid] = [];
      groups[pid].push(el);
    });

    Object.keys(groups).forEach(function (pid) {
      var group = groups[pid];
      group.sort(function (a, b) {
        return parseInt(a.getAttribute('data-pack-index') || '0', 10) -
               parseInt(b.getAttribute('data-pack-index') || '0', 10);
      });
      var master = group[0];

      // Idempotency: skip if this master is already fully decorated
      if (master.getAttribute('data-pack-decorated') === '1') return;

      // Mark as decorated BEFORE mutations so any re-entry sees this and bails
      master.setAttribute('data-pack-decorated', '1');

      // Server-rendered attributes (from cart-item.liquid via _pack_master property)
      // should already be correct, but ensure them defensively
      if (master.getAttribute('data-pack-master') !== '1') {
        master.setAttribute('data-pack-master', '1');
      }
      for (var i = 1; i < group.length; i++) {
        if (group[i].getAttribute('data-pack-master') !== '0') {
          group[i].setAttribute('data-pack-master', '0');
        }
      }

      decoratePackMaster(master, group);
      interceptPackQty(master, group);
      attachPackRemove(master, group);
    });

    recalcCartCount();
  }

  function decoratePackMaster(master, group) {
    var label = master.getAttribute('data-pack-label') || 'Pack';
    var imageUrl = master.getAttribute('data-pack-image-url') || '';
    var packHandle = master.getAttribute('data-pack-id') || '';
    var packUrl = packHandle ? ('/products/' + packHandle) : null;

    // Replace master image with pack image.
    // Also clear data-manual-src/srcset: the cart drawer lazy-loads images via
    // theme.manuallyLoadImages() when it (re)opens, which would otherwise
    // overwrite our pack image back to the first component's photo.
    if (imageUrl) {
      var imgs = master.querySelectorAll('.cart-item__image img');
      imgs.forEach(function (img) {
        img.setAttribute('src', imageUrl);
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('data-manual-src');
        img.removeAttribute('data-manual-srcset');
        delete img.dataset.manualSrc;
        delete img.dataset.manualSrcset;
        img.setAttribute('alt', label);
      });
    }
    // Point the image link to the PACK page (not the first component's product)
    if (packUrl) {
      var imgLink = master.querySelector('.cart-item__image a');
      if (imgLink) imgLink.setAttribute('href', packUrl);
    }

    // Replace master title with pack title; link it to the PACK page so clicking
    // opens the pack (not the component) and keeps the cart grouped as one pack.
    var titleEl = master.querySelector('.cart-item__title');
    if (titleEl) {
      var a = titleEl.querySelector('a');
      if (a) {
        a.textContent = label;
        if (packUrl) { a.setAttribute('href', packUrl); } else { a.removeAttribute('href'); }
        a.style.pointerEvents = '';
        a.style.fontWeight = '700';
      } else {
        titleEl.textContent = label;
      }
    }

    // ─── Show the PACK TOTAL price on the master (sum of all component lines) ───
    // The price column shows the first component's price by default; we replace
    // it with the sum of every component's line price so the pack reads like a
    // normal cart item (final total + struck-out original).
    // Sum BEFORE overwriting the master so master's own line is counted at its
    // original component value.
    var packFinal = 0, packCompare = 0, sawCompare = false;
    group.forEach(function (el) {
      var sp = el.querySelector('.cart-item__selling-price');
      var lineFinal = sp ? _parseMoney(sp.textContent) : 0;
      packFinal += lineFinal;
      var so = el.querySelector('.cart-item__price .struck-out-price');
      if (so) { packCompare += _parseMoney(so.textContent); sawCompare = true; }
      else { packCompare += lineFinal; }
    });

    var priceCol = master.querySelector('.cart-item__price');
    if (priceCol && packFinal > 0) {
      var sellEl = priceCol.querySelector('.cart-item__selling-price');
      if (sellEl) sellEl.textContent = _fmtMoney(packFinal);
      var strikeWrap = priceCol.querySelector('.struck-out-price');
      if (sawCompare && packCompare > packFinal + 0.001) {
        if (strikeWrap) {
          var strikeMoney = strikeWrap.querySelector('.theme-money') || strikeWrap;
          strikeMoney.textContent = _fmtMoney(packCompare);
          strikeWrap.style.display = '';
        }
      } else if (strikeWrap) {
        strikeWrap.style.display = 'none';
      }
    }

    // Build component summary text
    var byTitle = {};
    group.forEach(function (el) {
      var t = el.getAttribute('data-pack-component-title') || '';
      var s = el.getAttribute('data-pack-component-size') || '';
      s = s.split(' — ')[0].trim();
      if (!byTitle[t]) byTitle[t] = [];
      if (s) byTitle[t].push(s);
    });
    var parts = Object.keys(byTitle).map(function (t) {
      var shortTitle = t.replace(/^Braga Bikini Menstrual\s+/, '').replace(/^Braga Menstrual\s+/, '');
      return shortTitle + ': ' + byTitle[t].join(', ');
    });

    // Skip if we've already decorated
    if (master.querySelector('.cart-item-pack-summary')) return;

    // INSERT components summary AFTER the title (before qty controls)
    var titleParent = titleEl ? titleEl.parentElement : null;
    var summary = document.createElement('div');
    summary.className = 'cart-item-pack-summary';
    summary.textContent = parts.join(' · ');
    if (titleEl && titleEl.nextSibling) {
      titleEl.parentNode.insertBefore(summary, titleEl.nextSibling);
    } else if (titleParent) {
      titleParent.appendChild(summary);
    }

    // INSERT AHORRA EN PACKS pill AT THE BOTTOM of the not-image column
    var notImage = master.querySelector('.cart-item__not-image') || master.firstElementChild;
    var savings = document.createElement('div');
    savings.className = 'cart-item-pack-savings-wrap';
    savings.innerHTML = '<span class="cart-item-pack-savings">AHORRA EN PACKS</span>';
    if (notImage) notImage.appendChild(savings);
  }

  function interceptPackQty(master, group) {
    // Intercept "-" and "+" qty buttons. "-" removes the whole pack. "+" no-op (or could add another pack — disabled for now).
    var qtyDown = master.querySelector('.quantity-down, .js-qty-down, [aria-label*="ecrease"], [aria-label*="ecrement"]');
    var qtyUp   = master.querySelector('.quantity-up, .js-qty-up, [aria-label*="ncrease"], [aria-label*="ncrement"]');

    if (qtyDown && qtyDown.dataset.packIntercepted !== '1') {
      qtyDown.dataset.packIntercepted = '1';
      qtyDown.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        removeWholePack(group);
      }, true);
    }
    if (qtyUp && qtyUp.dataset.packIntercepted !== '1') {
      qtyUp.dataset.packIntercepted = '1';
      qtyUp.addEventListener('click', function (e) {
        // Disable + for now: prevent default action
        e.preventDefault();
        e.stopImmediatePropagation();
      }, true);
      // Also visually disable
      qtyUp.style.opacity = '0.35';
      qtyUp.style.pointerEvents = 'none';
      qtyUp.style.cursor = 'not-allowed';
    }

    // Show "1" (not the actual line item qty which may be 3)
    var qtyInput = master.querySelector('.cart-item__quantity-input[type="number"], input.cart-item__quantity-input:not([type="hidden"])');
    if (qtyInput) {
      qtyInput.value = '1';
      qtyInput.readOnly = true;
      qtyInput.dataset.packIntercepted = '1';
    }
    // Also adjust visible spans that show qty
    var visibleQty = master.querySelector('.cart-item__quantity-number, .quantity__number, .qty-number');
    if (visibleQty) visibleQty.textContent = '1';
  }

  function attachPackRemove(master, group) {
    var removeBtn = master.querySelector('.cart-item__remove');
    if (!removeBtn) return;
    if (removeBtn.dataset.packRemoveBound === '1') return;
    removeBtn.dataset.packRemoveBound = '1';

    removeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      removeWholePack(group);
    }, true);
  }

  function removeWholePack(group) {
    var updates = {};
    var anyKey = false;
    group.forEach(function (el) {
      var key = getLineItemKey(el);
      if (key) {
        updates[key] = 0;
        anyKey = true;
      }
    });

    if (!anyKey) {
      window.location.reload();
      return;
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Update failed: ' + r.status);
        return r.json();
      })
      .then(function () { return refreshDrawerSilently(); })
      .catch(function () { window.location.reload(); });
  }

  // ─── Recalculate cart count so a pack shows as 1 item ───
  // Idempotent: computes an ABSOLUTE target from the drawer DOM each time
  // (each unique pack = 1, each non-pack line = its quantity), then writes it.
  // Safe to run repeatedly — never double-subtracts.
  function recalcCartCount() {
    var drawer = document.querySelector('cart-drawer');
    var scope = drawer || document;
    var packItems = scope.querySelectorAll('.cart-item[data-pack-id]');
    if (!packItems.length) return; // no packs → the theme's own count is correct

    var seenPacks = {};
    var uniqueCount = 0;
    scope.querySelectorAll('.cart-item').forEach(function (el) {
      var pid = el.getAttribute('data-pack-id');
      if (pid) {
        if (!seenPacks[pid]) { seenPacks[pid] = true; uniqueCount += 1; }
      } else {
        var qtyInput = el.querySelector('.cart-item__quantity-input');
        var q = qtyInput ? parseInt(qtyInput.value || qtyInput.getAttribute('value') || '1', 10) : 1;
        uniqueCount += (isNaN(q) ? 1 : q);
      }
    });

    var selectors = [
      '.cart-link__count',
      '.cart-bubble',
      '.js-cart-count',
      '[data-cart-count]',
      '.cart-count',
      '.cart-drawer-popup__heading-count',
      '.cart-drawer__heading-count',
      '.drawer__heading-count',
      '.cart-drawer__title-count'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (/\d/.test(el.textContent)) {
          el.textContent = el.textContent.replace(/\d+/, String(uniqueCount));
        }
      });
    });
  }

  function bootCart() {
    decoratePackInCart(document);
    var drawer = document.querySelector('cart-drawer, .cart-drawer, .cart-item-list__body');
    if (!drawer || !window.MutationObserver) return;

    // Debounced observer callback — only fire once after DOM mutations settle.
    // This prevents runaway infinite loops when cart-drawer refreshes internally.
    var debounceTimer = null;
    _drawerObserver = new MutationObserver(function () {
      if (_isDecorating) return; // hard bail if our decorator is running
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { decoratePackInCart(document); }, 100);
    });
    _drawerObserver.observe(drawer, { childList: true, subtree: true });

    // The theme re-renders the header cart bubble on 'on:cart:change' AFTER we've
    // corrected it (that's the "count shows 1 then flips to 5" bug). Re-run our
    // grouping + count correction once the theme's update settles.
    var cartChangeTimer = null;
    document.addEventListener('on:cart:change', function () {
      if (cartChangeTimer) clearTimeout(cartChangeTimer);
      cartChangeTimer = setTimeout(function () { decoratePackInCart(document); }, 130);
    });
  }

  function boot() {
    initPackPage();
    initSizeGuideModals();
    bootCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
